<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <span class="active">{{  current_user }} </span>
       <!--   <img src="static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com"> -->
        </template>
        <span v-show="view" >
          <b-dropdown-header tag="div" class="text-center"><strong>Current Login</strong></b-dropdown-header>
          <b-dropdown-item class="text-success"><i class="fa fa-shield"></i> {{role}}</b-dropdown-item>
        </span>
        <b-dropdown-item @click="getProfile"><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown-accnt',
    created: function () {
      var current_role = localStorage.getItem('role')
      if ( current_role == 'super_analyst') {
       this.role = current_role
        this.view = true
      }else if (current_role == 'analyst') {
        this.role = current_role
        this.view = true
      }else if (current_role == 'marketing_accountant') {
        this.role = current_role
        this.view = true
      }else if (current_role == 'operations_manager') {
        this.role = current_role
        this.view = true
      }
      else if (current_role == 'driver') {
        this.role = current_role
        this.view = true
      }else if (current_role == 'trucking_company_admin' || current_role == 'trucking_operational_manager') {
        this.role = current_role
        this.view = true
      } else {this.view = false }
    },
    data: () => {
      return {
        itemsCount: 42,
        current_user: localStorage.getItem('full_name'),
        role: '', // localStorage.getItem('role')
        view : true,
        userID : localStorage.getItem('user_id')
      }
    },
    methods: {
			getProfile() {
        this.$router.push('/profile/' + this.userID)
      },
      logout() {
        this.$router.push('/logout')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue